<template>
    <div class="row">
        <div class="col-sm-5">
            <form @submit.prevent="submit">
                <legend>Проверка карт</legend>
                <div class="form-group">
                    <label>Номер карты</label>
                    <input type="number"  placeholder="1003017" class="form-control" v-model="cardNumber" required />
                </div>

                <div class="form-group">
                    <label>Электронная почта или ФИО</label>
                    <input type="text" placeholder="Электронная почта или ФИО" class="form-control" v-model="extraInfo" required />
                    <ul class="form-text text-muted" style="font-size: smaller">
                        <li>
                            ФИО полностью по-русски
                        </li>
                        <li>
                            ИЛИ имя и фамилия латиницей (как на карте)
                        </li>
                        <li>
                            ИЛИ адрес электронной почты
                        </li>
                    </ul>
                </div>

                <button type="submit" class="btn btn-primary btn-large">Проверить</button>
            </form>
        </div>
        <div class="col-sm-5">
            <check-result v-for="(check,i) in checks" :key="check.time" :cardNumber="check.cardNumber" :name="check.name" :email="check.email" @remove="remove(i)" />
        </div>
    </div>
</template>

<script>

export default {
    props: {
        cardNumberDefault: String,
        extraInfoDefault: String,
    },
    data() {
        return {
            cardNumber: this.cardNumberDefault || '',
            extraInfo: this.extraInfoDefault || '',
            checks: [ ],
        }
    },
    computed: {
        isEmail() {
            return !!this.extraInfo.match(/@/);
        },
        email() {
            return this.isEmail ? this.extraInfo : null;
        },
        name() {
            return this.isEmail ? null : this.extraInfo;
        },
    },
    methods: {
        submit() {
            this.checks.splice(0, 0, {cardNumber: this.cardNumber, email: this.email, name: this.name, time: Date.now()} )
        },
        remove(i) {
            this.checks.splice(i, 1);
        }
    },
    components: {
        'check-result': require('./memberCardCheckResult').default
    }
}
</script>
